<template>
  <div class="empty">
    <el-empty description="无权限使用该产品">
      <!-- <el-button type="primary" @click="open">前往开通</el-button> -->
    </el-empty>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  mounted () {

    // console.log(this.$route.query)

  },
  methods: {
    open () {
      this.$router.push({ name: "product" })
    }
  }
}
</script>    

<style scoped lang="less">
.empty {
  box-sizing: border-box;
  margin: 16px;
  background: white;
  height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
